import { render, staticRenderFns } from "./expenses-types-autocomplete.vue?vue&type=template&id=12094402&"
import script from "./expenses-types-autocomplete.vue?vue&type=script&lang=js&"
export * from "./expenses-types-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports